<form #typePoiForm="ngForm" class="form-horizontal">
    <div class="box-body">
        <div class="form-group has-success form-horizontal">

            <!--================================= Nom ====================================-->
            <label class="col-sm-1 control-label">Nom *</label>
            <div class="col-lg-3 col-md-3">
                <input type="text" [(ngModel)]="typePoiRequest.nom" name="nom" #typeName="ngModel" class="form-control input-sm" placeholder="Nom"
                    required maxlength="50">
            </div>

            <!--================================= Color ====================================-->
            <label class="col-sm-1 control-label">Coleur</label>
            <div class="col-lg-3 col-md-3">
                <select class="form-control input-sm" [(ngModel)]="typePoiRequest.color" name="color" #color="ngModel" (change)="getIcons()">
                    <option *ngFor="let color of colors" [selected]="color.color === typePoiRequest.color"
                    [value]="color.color"
                    [ngStyle]="{'background-color': color.color,'margin-bottom':'10px'}">
                        {{color.name}}
                    </option>
                </select>
            </div>

            <!--================================= Icon ====================================-->
            <label class="col-sm-1 control-label">Icon</label>
            <div class="col-lg-3 col-md-3">
                <ul class="nav nav-tabs pull-right" style="border: 1px solid #ccc;width: 100%;">
                    <li class="dropdown" style="width: 100%;">
                    <a class="dropdown-toggle" data-toggle="dropdown" aria-expanded="true" style="padding: 5px 10px;">
                        <img *ngIf="typePoiRequest && typePoiRequest.imageUri != ''" src="{{typePoiRequest.imageUri}}" style="height: 22px;top: 17px;left: -31px;font-weight: normal;" alt="Icon" class="rounded-circle me-20" width="17px">
                        {{selectedIconName}}
                    </a>
                    <ul class="dropdown-menu" style="width: 100%;">
                        <li *ngFor="let icon of icons" (click)="chooseIcon(icon)" style="display: flex;align-items: center;gap: 10px;">
                        <img src="{{icon.url}}" style="height: 22px;top: 17px;left: -31px;font-weight: normal;" alt="Icon" class="rounded-circle me-20" width="17px">
                        {{icon.name}}
                        </li>
                    </ul>
                    </li>
                </ul>
            </div>


            <!--================================= Pois ====================================-->
            <label class="col-sm-1 control-label">Pois</label>
            <div class="col-lg-3 col-md-3">
                <ng-multiselect-dropdown
                name="poiSelect"
                [data]="poiItems"
                placeholder="select Pois"
                [(ngModel)]="poiSelected"
                [settings]="poiDropdownSettings" >
                </ng-multiselect-dropdown>

            </div>
            <div >
                <a style="margin-right: 10px;" class="pull left" >
                    <button (click)="fileInput.click()" type="button" class="btn btn-success ">
                        <i class="fa fa-upload"></i>
                    </button>
                </a>
                <input style="display: none" type="file" name="file" (input)="onFileChanged($event)" accept=".xlsx" #fileInput>
                <a class="pull left" href="{{templateDownoaldLocation}}TemplateExcel/{{template}}" download>
                    <button  type="button" class="btn btn-success ">
                        <i class="fa fa-download"></i>
                    </button>
                </a>

            </div>

        </div>

        <div class="box-footer">
            <button type="submit" *ngIf="mode == 'ADD'" [disabled]="!typePoiForm.form.valid" class="btn btn-info pull-right" (click)="onAdd(typePoiForm)">
                <i class="fa fa-spinner fa-spin" *ngIf="loading"></i> Enregistrer
            </button>
            <button type="submit" *ngIf="mode == 'UPDATE'" [disabled]="!typePoiForm.form.valid" class="btn btn-info pull-right" (click)="onUpdate(typePoiForm)">
                <i class="fa fa-spinner fa-spin" *ngIf="loading"></i> Valider
            </button>
            <button type="reset" class="btn btn-default" (click)="typePoiModal.hide()">Annuler</button>
        </div>
    </div>
</form>
